import React from "react";
import "./AuroraBackground.less";

const AuroraBackground = ({ children, className = "", style }) => {
  const cls = `aurora-page${className ? ` ${className}` : ""}`;
  return (
    <div className={cls} style={style}>
      <div className="aurora-page__orb aurora-page__orb--purple" aria-hidden />
      <div className="aurora-page__orb aurora-page__orb--teal" aria-hidden />
      <div className="aurora-page__content">{children}</div>
    </div>
  );
};

export default AuroraBackground;
